/** Qué dictar para que receta ACESS e historia 033 queden alineadas. */
export const ANAMNESIS_PROTOCOL = [
  {
    say: 'Apellidos y nombres completos, cédula, sexo y fecha de nacimiento.',
    mapsTo: 'HCU 033 filiación · receta: datos del usuario',
  },
  {
    say: 'Edad. Si es menor de cinco años, años y meses.',
    mapsTo: 'ACESS-2023-0030 art. 5.b.ii',
  },
  {
    say: 'Alergias a medicamentos, látex o anestésicos. Si no hay, dígalo explícito.',
    mapsTo: 'Receta art. 5.b.iv y historia antecedentes',
  },
  {
    say: 'Motivo de consulta y enfermedad actual.',
    mapsTo: 'HCU 033 bloques 2',
  },
  {
    say: 'Examen estomatológico y pieza FDI del odontograma.',
    mapsTo: 'HCU 033 examen y odontograma (no alterar ni repintar)',
  },
  {
    say: 'Diagnóstico CIE-10 vigente, el más específico. Marque PRE o DEF.',
    mapsTo: 'Receta art. 5.b.iii · historia diagnóstico · LOSNS art. 76',
  },
  {
    say: 'Medicamento por Denominación Común Internacional, sin marca ni abreviaturas.',
    mapsTo: 'LOS arts. 7.g y 167 · receta art. 5.c.i (DCI primero)',
  },
  {
    say: 'Forma farmacéutica, concentración y vía de administración.',
    mapsTo: 'Receta art. 5.c.ii–iv',
  },
  {
    say: 'Cantidad en números y en letras.',
    mapsTo: 'Receta art. 5.c.v · control ACESS art. 61',
  },
  {
    say: 'Dosis, frecuencia y duración del tratamiento.',
    mapsTo: 'Receta art. 5.c.vi',
  },
  {
    say: 'Signos de alarma y recomendaciones no farmacológicas.',
    mapsTo: 'Indicaciones desprendibles art. 5.e',
  },
  {
    say: 'Su nombre y número de registro ACESS para firma y sello (no rúbrica).',
    mapsTo: 'Receta art. 5.d · vigencia consulta externa 3 días',
  },
] as const;
